import MessageStrip from './MessageStrips';


const messageString = {
    MessageStrip
  };
  export default messageString;
  
